// extracted by mini-css-extract-plugin
module.exports = {"Main":"AppFeedback_Main__2zQwD","DialogMain":"AppFeedback_DialogMain__3b4A8","DialogActions":"AppFeedback_DialogActions__3Taue"};